import cookies from "react-cookies";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import request from "./request";
import { getStoreKeyData, storeData } from "indexedb";
dayjs.extend(isSameOrBefore);
export function getCookie(cookie_name) {
    return cookies.load(cookie_name);
}

export function getToken() {
    return getCookie("token");
}

export function removeCookie(cookie_name) {
    return cookies.remove(cookie_name, { path: "/" });
}

export function deleteToken() {
    cookies.remove("token", { path: "/" });
}

export function setCookie(cookie_name, cookie_value) {
    cookies.save(cookie_name, cookie_value, { path: "/" });
}

export function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== "";
}

export async function fetchS3KpiData(params) {
    try {
        const { recording_date, patient_id, device_id } = params;
        const cache_key = `${patient_id}-${device_id}-${recording_date}`;

        const cachedData = await getStoreKeyData(cache_key);
        const selected_recording_date = dayjs(recording_date).format("YYYYMMDD");
        const { data, status } = await request({
            path: `/s3/analytics/patient?recording_date=${selected_recording_date}&patient_id=${patient_id}&device_id=${device_id}`,
            method: "GET",
        });

        if (!data) return { recording_meta: "NULL", data: "NULL" };

        if (cachedData) {
            cachedData["recording_meta"] = data.data;
            return cachedData;
        }

        const res = await fetch(data.link, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        const jsonText = await res.text();
        const parsedJson = JSON.parse(jsonText.replace(/NaN/g, null));

        await storeData({ status, data: parsedJson }, cache_key);

        return {
            status,
            recording_meta: data.data,
            data: parsedJson,
        };
    } catch (err) {
        console.log("printed-error: ", err);
    }
}

var enumerateDaysBetweenDates = function (startDate, endDate) {
    var now = dayjs(startDate).clone(),
        dates = [];
    console.log(now.isSameOrBefore(endDate));
    while (now.isSameOrBefore(endDate, "day")) {
        dates.push(now.format("YYYYMMDD"));
        now = now.add(1, "days");
    }
    return dates;
};

export async function fetchS3KpiDataByDateRange(params) {
    const { start_date, end_date, patient_id, device_id } = params;
    const dates = enumerateDaysBetweenDates(dayjs(start_date), dayjs(end_date));
    const actigraph_data_by_date = {},
        actigraph_meta = {};
    for (let i = 0; i < dates.length; i++) {
        try {
            const { data, recording_meta } = await fetchS3KpiData({
                recording_date: dates[i],
                patient_id,
                device_id,
            });

            if (data === "NULL") continue;

            actigraph_data_by_date[dates[i]] = data;
            actigraph_meta[dates[i]] = recording_meta;
        } catch (error) {
            console.log("error fetching for: ", error, dates[i]);
        }
    }
    return {
        actigraph: actigraph_data_by_date,
        actigraph_meta,
    };
}

export async function fetchAnnotationsFromS3(params) {
    try {
        const sql_annotations = await request({
            path: `/analytics/patient/get-annotations`,
            method: "POST",
            body: JSON.stringify(params),
        });

        const s3kpidata = await fetchS3KpiData({
            recording_date: params.recording_date,
            patient_id: params.patient_id,
            device_id: params.device_id,
        });
        const { data } = s3kpidata;

        let no_system_annotations = false,
            no_system_desaturations = false;

        // DSAT
        const dsat_annotations = data.find((d) => d.kpi === "DSAT");
        if (dsat_annotations && dsat_annotations.device_values.length > 0) {
            const dsat_device_values = dsat_annotations.device_values;

            let desaturation_events = [],
                activeIndex = 0;
            dsat_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    desaturation_events.push({ start_time: v });
                } else {
                    desaturation_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (desaturation_events.length === 0) {
                no_system_desaturations = true;
            }
        } else {
            no_system_desaturations = true;
        }

        // AP_Timing
        const ap_annotations = data.find((d) => d.kpi === "AP_timing");
        if (ap_annotations && ap_annotations.device_values.length > 0) {
            const apnea_device_values = ap_annotations.device_values;

            let apnea_events = [],
                activeIndex = 0;
            apnea_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    apnea_events.push({ start_time: v });
                } else {
                    apnea_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (apnea_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Heart Rate
        const hr_annotations = data.find((d) => d.kpi === "HR");
        if (hr_annotations && hr_annotations.device_values.length > 0) {
            const hr_device_values = hr_annotations.device_values;

            let hr_events = [],
                activeIndex = 0;
            hr_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    hr_events.push({ start_time: v });
                } else {
                    hr_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (hr_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Breathing Rate
        const br_annotations = data.find((d) => d.kpi === "BR");
        if (br_annotations && br_annotations.device_values.length > 0) {
            const br_device_values = br_annotations.device_values;

            let br_events = [],
                activeIndex = 0;
            br_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    br_events.push({ start_time: v });
                } else {
                    br_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (br_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Chest Displacement
        const ydist_annotations = data.find((d) => d.kpi === "Y_DIST");
        if (ydist_annotations && ydist_annotations.device_values.length > 0) {
            const ydist_device_values = ydist_annotations.device_values;

            let ydist_events = [],
                activeIndex = 0;
            ydist_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    ydist_events.push({ start_time: v });
                } else {
                    ydist_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (ydist_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Body Movement
        const mov_annotations = data.find((d) => d.kpi === "MOV");
        if (mov_annotations && mov_annotations.device_values.length > 0) {
            const mov_device_values = mov_annotations.device_values;

            let mov_events = [],
                activeIndex = 0;
            mov_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    mov_events.push({ start_time: v });
                } else {
                    mov_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (mov_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Time in bed
        const tb_annotations = data.find((d) => d.kpi === "TB");
        if (tb_annotations && tb_annotations.device_values.length > 0) {
            const tb_device_values = tb_annotations.device_values;

            let tb_events = [],
                activeIndex = 0;
            tb_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    tb_events.push({ start_time: v });
                } else {
                    tb_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (tb_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // I
        const i_annotations = data.find((d) => d.kpi === "I");
        if (i_annotations && i_annotations.device_values.length > 0) {
            const i_device_values = i_annotations.device_values;

            let i_events = [],
                activeIndex = 0;
            i_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    i_events.push({ start_time: v });
                } else {
                    i_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (i_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Q
        const q_annotations = data.find((d) => d.kpi === "MOV");
        if (q_annotations && q_annotations.device_values.length > 0) {
            const q_device_values = q_annotations.device_values;

            let q_events = [],
                activeIndex = 0;
            q_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    q_events.push({ start_time: v });
                } else {
                    q_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (q_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        // Sleep awake
        const sa_annotations = data.find((d) => d.kpi === "MOV");
        if (sa_annotations && sa_annotations.device_values.length > 0) {
            const sa_device_values = sa_annotations.device_values;

            let sa_events = [],
                activeIndex = 0;
            sa_device_values.forEach((v, i) => {
                const actualIndex = i + 1;
                if (actualIndex % 2 !== 0) {
                    sa_events.push({ start_time: v });
                } else {
                    sa_events[activeIndex].end_time = v;
                    activeIndex++;
                }
            });
            if (sa_events.length === 0) {
                no_system_annotations = true;
            }
        } else {
            no_system_annotations = true;
        }

        return {
            data: {
                annotations: sql_annotations.data.annotations,
                no_system_annotations,
                no_system_desaturations,
            },
            status: sql_annotations.status,
        };
    } catch (error) {
        console.log("error fetching annotations: ", error);
        return null;
    }
}

export const get_token = getToken;

export function validateSearchText(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
        (charCode > 32 && charCode < 48) ||
        (charCode > 57 && charCode < 65) ||
        (charCode > 90 && charCode < 97) ||
        (charCode > 122 && charCode < 127)
    )
        return true;

    if (
        !(charCode > 47 && charCode < 58) &&
        !(charCode > 64 && charCode < 91) &&
        !(charCode > 96 && charCode < 123)
    ) {
        evt.preventDefault();
        return false;
    }

    if (evt.target.value.toString().length > 9) {
        evt.preventDefault();
        return false;
    }

    return true;
}

export const defaultWindowStartTime = "19:00:00";
export const defaultWindowEndTime = "11:00:00";
